/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ColumnDetailFormComponent as ɵc} from './columndetail-form/columndetail-form.component';
export {ColumnDetailComponent as ɵb} from './columndetail.component';
export {declaration as ɵa} from './columndetail.module';
export {ColumnDetailRoutes as ɵd} from './columndetail.routing';